import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const longTextSettings = {
  ...commonDefaultSettings,
  label: 'Long Text',
  placeholder: '',
  hint: '',
  fieldID: 'long_text'
};
